import React from 'react';

import { useAppInfo } from 'AppState';
import ChatHome from 'chat/ChatHome';
import ComingSoon from 'components/ComingSoon';
import FinancialCalculator from 'myFinancials/Calculator/FinancialCalculator';
import MarketNews from 'newsEvents/MarketNews';
import { Peers } from 'peerList/Peers';
import { WatchList } from 'watchlist/WatchList';

import Hotlist from './Hotlist';
import Information from './Information';
import Notes from './Notes';
import Resizer from './Resizer';
import SettingsSidebar from './SettingsSidebar';

export default function SidebarRightContent() {
    const {stateSidebar} = useAppInfo()
    const sidebarContent = {};
    sidebarContent["watchlist"] = (
      <WatchList/>
    );
    sidebarContent["peers"] = (
      <Peers/>
    );

    sidebarContent["notifications"] =<ComingSoon name={"Notifications"}/>
    sidebarContent["information"] = (<Information/>)
    sidebarContent["chat"] = <ChatHome/>
    sidebarContent["settings"] = (<SettingsSidebar openSettings={true}/>)
    sidebarContent["hotlist"] = (<Hotlist/>)
    sidebarContent["notes"] = (<Notes/>)
    sidebarContent["help"] = <ComingSoon name={"Help"}/>
    sidebarContent["news"] = (<MarketNews/>)
    // sidebarContent["calendar"] = (<Calendar/>)
    sidebarContent["calculator"] = <FinancialCalculator/>

  return (
    <Resizer orientV={true}>{sidebarContent[stateSidebar.sidebarRightContent]}</Resizer>
  )
}
